import { config } from "../config";
import { HttpServices } from "../Helper";

export const GetAllAMLTransactions = async (unitTransactionId, body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAllAMLTransactions/${unitTransactionId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const TransactionManualApprove = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionManualApprove`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const TransactionComplete = async (unitTransactionId) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionComplete/${unitTransactionId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const TransactionManualCancel = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionManualCancel`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllTrackedTransactions = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAllTrackedTransactions`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllBranchTrackedTransactions = async (userBranchId, body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAllBranchTrackedTransactions?branchId=${userBranchId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllMyTrackedTransactions = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAllMyTrackedTransactions`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllMyAMLTransactions = async (unitTransactionId, body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAllMyAMLTransactions/${unitTransactionId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UpdateAMLTransactionStatus = async (contactId, isApproved) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/UpdateAMLTransactionStatus?contactId=${contactId}1&isApproved=${isApproved}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const AddAMLRevision = async (amlTransactionId, comment) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/AddAMLRevision/${amlTransactionId}?comment=${comment}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const TransactionReassignedToRequester = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionReassignedToRequester`,
    body
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const TransactionWithdraw = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionWithdraw`,
    body
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const GetTrackedTransactionDocuments = async (amlTransactionId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/UnitTransaction/GetTrackedTransactionDocuments/${amlTransactionId}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const GetAMLTrackedTransactionDocuments = async (amlTransactionId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAMLTransactionDocuments/${amlTransactionId}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const UploadTransactionDocuments = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/UploadTransactionDocuments`,
    body
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const UploadAMLTransactionDocuments = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/UploadAMLTransactionDocuments`,
    body
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const TransactionResubmit = async (unitTransactionId) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitTransaction/TransactionResubmit/${unitTransactionId}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const DeleteAMlTransactionDocument = async (unitTransactionId) => {
  const result = await HttpServices.delete(
    `${config.server_address}/CrmDfm/UnitTransaction/DeleteAMlTransactionDocument/${unitTransactionId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAmlTransactionHistory = async (unitTransactionId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/UnitTransaction/GetAmlTransactionHistory/${unitTransactionId}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};

export const ExportAMLHistory = async (
  unitTransactionId,
  isSaleTransaction
) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/ExportAMLHistory?unitTransactionId=${unitTransactionId}&isSaleTransaction=${isSaleTransaction}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetTransactionsAMLLogsAPI = async ({
  pageIndex,
  pageSize,
  body,
}) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/GetTransactionsAMLLogs?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const ExportTransactionsAMLLogsAPI = async ({
  pageIndex,
  pageSize,
  body,
}) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/ExportTransactionsAMLLogs?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const CreateUnitTransactionTempData = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitTransaction/CreateUnitTransactionTempData`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetUnitTransactionTempData = async (key, unitId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/UnitTransaction/GetUnitTransactionTempData/?key=${key}&unitId=${unitId}`
  )
    .then((data) => data)
    .catch((error) => {
      console.error("Error during API request:", error);
      return error.response;
    });
  return result;
};
export const GetAllClubTransactionAPI = async ({
  contactId,
  pageIndex,
  pageSize,
  transactionStatusId,
  commissionStatus,
  leadId,
  leadName,
  memberId,
  adminMemberId,
  commissionPaymentDate,
  CommissionPaymentDateFrom,
  CommissionPaymentDateTo,
}) => {
  const queryList = [];
  if (contactId) queryList.push(`ContactId=${contactId}`);
  if (pageIndex) queryList.push(`PageIndex=${pageIndex}`);
  if (pageSize) queryList.push(`PageSize=${pageSize}`);
  if (adminMemberId) queryList.push(`AdminMemberId=${adminMemberId}`);
  if (transactionStatusId)
    queryList.push(`transactionStatusId=${transactionStatusId}`);
  if (commissionStatus) queryList.push(`CommissionStatus=${commissionStatus}`);
  if (leadId) queryList.push(`LeadId=${leadId}`);
  if (leadName) queryList.push(`LeadName=${leadName}`);
  if (commissionPaymentDate)
    queryList.push(`CommissionPaymentDate=${commissionPaymentDate}`);
  if (memberId) queryList.push(`MemberId=${memberId}`);
  if (CommissionPaymentDateTo)
    queryList.push(`CommissionPaymentDateTo=${CommissionPaymentDateTo}`);
  if (CommissionPaymentDateFrom)
    queryList.push(`CommissionPaymentDateFrom=${CommissionPaymentDateFrom}`);

  const result = await HttpServices.get(
    `${
      config.server_address
    }/CrmDfm/UnitTransaction/GetAllClubTransaction?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetClubTotalCommissionAPI = async ({ memberId, contactId }) => {
  const queryList = [];
  if (contactId) queryList.push(`ContactId=${contactId}`);
  if (memberId) queryList.push(`MemberId=${memberId}`);

  const result = await HttpServices.get(
    `${
      config.server_address
    }/CrmDfm/UnitTransaction/GetClubTotalCommission?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetClubMonthlyCommissionAPI = async ({ year, contactId }) => {
  const queryList = [];
  if (contactId) queryList.push(`ContactId=${contactId}`);
  if (year) queryList.push(`year=${year}`);

  const result = await HttpServices.get(
    `${
      config.server_address
    }/CrmDfm/UnitTransaction/GetClubMonthlyCommission?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
